import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _get from "lodash/get";
import {connect} from 'react-redux';
import EditIVRPrefForm from './EditIVRPrefForm';
import {accountContactPreferences} from '../../actions/account';
import {Loader} from '../../components/widgets/Loader';
import {getLangCode, stringBundle} from '../../stringBundle';
import utils from '../../helpers/utils';
import {authUserType} from "../../helpers/propCheck";
import _isEmpty from 'lodash/isEmpty';

class ContactIVRPref extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  handleSubmit(values) {
    let accountId = _get(this.props.auth, 'currentLoggedInUser.accountId');
    let getPrefData = { method: 'get', origin: 'IVR' }
    let updatePrefData = {};

    if (values.ivr === this.localizedStringBundle.MANAGE_ACCOUNT_OPT_OUT) {
      updatePrefData = {
        method: 'post',
        body: {
          voiceOptIn: false
        },
        origin: 'IVR'
      }
    }
    else {
      updatePrefData = {
        method: 'post',
        body: {
          voiceOptIn: true
        },
        origin: 'IVR'
      }
    }

    Promise.resolve(this.props.dispatch(accountContactPreferences(updatePrefData, null, accountId)))
    .then(() => {
      this.props.dispatch(accountContactPreferences(getPrefData, null, accountId));
      utils.trackEventForManageAccount('Contact_Call', this.localizedStringBundle.MANAGE_ACCOUNT_SAVE, true);
    });
  }

  render() {
    const propPrefStatus = _get(this.props, 'propAccount.status', '');
    const propPrefOrigin = _get(this.props, 'propAccount.prefOrigin', '');

    if (_isEmpty(this.props.propPreferences) || ((propPrefStatus === 'ACCOUNT_CONTACT_PREF_GET_REQUEST' || propPrefStatus === 'ACCOUNT_CONTACT_PREF_UPDATE_REQUEST') && propPrefOrigin === 'IVR')) {
      return (
        <div>
          <Loader/>
        </div>
      );
    }
    return (
      <div>
        <EditIVRPrefForm
          propPreferences={this.props.propPreferences}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }

}

ContactIVRPref.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: authUserType,
  propPreferences: PropTypes.object
};

function mapStateToProps(state) {
  const { form, auth, account } = state; // TODO why do we need form here?
  return { form: form.editivrpref, auth, propAccount: account };
}

export default connect(mapStateToProps)(ContactIVRPref);



// WEBPACK FOOTER //
// ./src/containers/monitoring/ContactIVRPref.js